var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToDoToolbarWidgetIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12.998 2.584c-.767 0-1.503.305-2.045.847L7.689 6.695a11.822 11.822 0 00-3.11 5.492l-.158.631a1.018 1.018 0 001.235 1.235l.631-.157a11.822 11.822 0 005.492-3.11l3.264-3.264a2.892 2.892 0 00-2.045-4.938zm-.985 1.908a1.393 1.393 0 011.97 1.97l-.474.473c-.372.046-.891-.14-1.36-.609-.47-.469-.656-.989-.609-1.36l.473-.474zm-.925 2.895c.317.317.718.609 1.164.805L10.72 9.725a10.323 10.323 0 01-4.646 2.677 10.322 10.322 0 012.676-4.646l1.534-1.534c.196.446.487.847.805 1.165z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.309 15.916a.75.75 0 000 1.5h11.666a.75.75 0 000-1.5H4.31z"
  })));
}
export default SvgToDoToolbarWidgetIcon;